import SensorsIcon from '@mui/icons-material/Sensors';
import { Box, Stack, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';

import DataUsageTab from '../../components/MediaStatus/DataUsageTab.js';
import DowntimeTab from '../../components/MediaStatus/DowntimeTab.js';
import LiveStatusTab from '../../components/MediaStatus/LiveStatusTab.js';

type MediaStatusTab = 'live' | 'usage' | 'downtime';

const MediaStatusDashboard = () => {
  const [tab, setTab] = useState<MediaStatusTab>('live');

  return (
    <Box sx={{ m: 2 }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <SensorsIcon color="primary" />
        <Typography variant="h4" component="h1">
          Media Status
        </Typography>
      </Stack>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        MediaMTX servers and their streams: live health, data usage, and connection drops.
      </Typography>

      <Tabs value={tab} onChange={(_, value: MediaStatusTab) => setTab(value)} sx={{ mb: 2 }}>
        <Tab value="live" label="Live status" />
        <Tab value="usage" label="Data usage" />
        <Tab value="downtime" label="Downtime" />
      </Tabs>

      {tab === 'live' ? <LiveStatusTab /> : null}
      {tab === 'usage' ? <DataUsageTab /> : null}
      {tab === 'downtime' ? <DowntimeTab /> : null}
    </Box>
  );
};

export default MediaStatusDashboard;
